import { render, staticRenderFns } from "./BackupManager.vue?vue&type=template&id=26c6ce0a"
import script from "./BackupManager.vue?vue&type=script&lang=js"
export * from "./BackupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports